import { render, staticRenderFns } from "./full_store_preview.vue?vue&type=template&id=87a9ef4a&"
import script from "./full_store_preview.vue?vue&type=script&lang=js&"
export * from "./full_store_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports